<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content class="text-read">{{data.text}}</div>
<div mat-dialog-actions align="end">
  <button *ngIf="data.cancel" mat-raised-button [mat-dialog-close]="false" cdkFocusInitial (click)="dialogAccepted(false)" >{{data.cancel}}</button>
  <button *ngIf="data.accept" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="dialogAccepted(true)">{{data.accept}}</button>
</div>
